import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

const mobileQuery = window.matchMedia('(max-width: 749px)');

window.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.proclad-footer__form')) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  const scrollTop = pageWrapper && getComputedStyle(pageWrapper).overflowY !== 'visible'
    ? pageWrapper.scrollTop
    : window.scrollY;
  try {
    sessionStorage.setItem('proclad-newsletter-scroll', String(scrollTop));
  } catch (_) {
  }
}, { capture: true });

function syncProcladFooterSwipers() {
  document.querySelectorAll('[data-proclad-footer-swiper]').forEach((strip) => {
    if (!mobileQuery.matches) {
      strip.procladFooterSwiper?.destroy(true, true);
      strip.procladFooterSwiper = undefined;
      return;
    }

    if (strip.procladFooterSwiper) return;

    strip.procladFooterSwiper = new Swiper(strip, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
  });
}

syncProcladFooterSwipers();
mobileQuery.addEventListener('change', syncProcladFooterSwipers);
document.addEventListener('shopify:section:load', syncProcladFooterSwipers);
